// Who may delete what, and who may give a done task's credit. Shared by the server routes and both
// clients so the rule and its refusal copy live in one place (docs/members.md "Deleting",
// docs/credit.md "Who").
import type { Role } from "./members.ts";
import { sameCreditName } from "./credit.ts";

/** Who may delete a task or remove a pinned note: a steward, or the person who made it (docs/members.md "Deleting"). A house thing with no author (created_by null) is a steward's to delete. */
export function canDelete(me: { name: string; role: Role }, createdBy: string | null | undefined): boolean {
  if (me.role === "steward") return true;
  return typeof createdBy === "string" && createdBy !== "" && createdBy === me.name;
}

/** The plain refusal a member sees when canDelete says no. */
export function deleteRefusal(kind: "task" | "note" | "entry", createdBy: string | null | undefined): string {
  const verb = kind === "task" ? "delete this task" : kind === "note" ? "remove this note" : "remove this line";
  return createdBy ? `Only ${createdBy} or a steward can ${verb}.` : `Only a steward can ${verb}.`;
}

/**
 * Who may give a task's credit to another peon (docs/credit.md, flag giveCreditUI): the task is done,
 * and the caller is the peon who holds the credit (`done_by`, matched ignoring case and spacing, as a
 * claim's holder is) or a steward. A role not known yet is a peon's. The refusal is shared/credit.ts
 * `creditRefusal`.
 */
export function canGiveCredit(task: { status: string; done_by: string | null }, name: string, role: Role | null | undefined): boolean {
  if (task.status !== "done") return false;
  if (role === "steward") return true;
  return typeof task.done_by === "string" && task.done_by.trim() !== "" && sameCreditName(task.done_by, name);
}
